import { Avatar, CircularProgress, useMediaQuery } from '@material-ui/core';
import moment from 'moment';
import { useMemo, useState } from 'react';
import './calendar.css';
import CalendarEventModal from './CalendarEventModal';
import EventsDrawer from './EventsDrawer';

const WeeklyCalendar = ({ week, loading, events, refresh, setRefresh, printView }) => {
	const [filterEvent, setFilterEvent] = useState([]);
	const [currentday, setcurrentday] = useState(null);
	const [eventsDrawerOpen, setEventsDrawerOpen] = useState(false);
	const [eventModalOpen, setEventModalOpen] = useState(false);
	const [currentSelectedEvent, setCurrentSelectedEvent] = useState(null);
	const isCompact = useMediaQuery('(max-width:600px)');

	const handleOpenEventsDrawer = (event, day) => {
		setcurrentday(day);
		setFilterEvent(
			events.filter(
				(event) =>
					new Date(`${event.datetime}`).getDate() === day.toDate().getDate() &&
					new Date(`${event.datetime}`).getMonth() === day.toDate().getMonth()
			)
		);
		setEventsDrawerOpen(true);
	};

	const handleCloseEventsDrawer = () => {
		setEventsDrawerOpen(false);
	};
	return (
		<>
			{!printView ? (
				<>
					<EventsDrawer
						currentDay={currentday}
						filterEvent={filterEvent}
						fixed={isCompact}
						onClose={handleCloseEventsDrawer}
						open={eventsDrawerOpen}
						refresh={refresh}
						setRefresh={setRefresh}
					/>
					<CalendarEventModal
						event={currentSelectedEvent}
						open={eventModalOpen}
						refresh={refresh}
						setOpen={setEventModalOpen}
						setRefresh={setRefresh}
					/>
				</>
			) : null}
			<div>
				<table className="event-table-container bg-white table-fixed">
					<thead style={{ width: '100%', tableLayout: 'fixed' }}>
						<tr>
							<th style={{ textAlign: 'center', width: '60px' }}>Day</th>
							<th style={{ textAlign: 'center', width: '100%' }}>Events</th>
						</tr>
					</thead>
					<tbody>
						{week.map((day, key) => {
							return (
								<tr key={key}>
									<td style={{ textAlign: 'center', width: '14.2%' }}>
										<button
											className={`hover:shadow-md cursor-pointer week-days ${
												moment(day).isSame(moment(), 'day') && !printView ? 'current-date' : ''
											}`}
											onClick={() => handleOpenEventsDrawer(null, day)}
											style={{ border: 'none', padding: 5, textAlign: 'center' }}
											type="button"
										>
											<span className="day">{moment(day).format('ddd')}</span>
											<span className="date">{moment(day).format('DD')}</span>
										</button>
									</td>
									<td className="p-10" style={{ textAlign: 'center', width: '85.8%' }}>
										<div className="flex flex-col gap-10">
											{events
												.filter((event) => new Date(event.datetime).getDate() === new Date(day).getDate())
												.map((event) => (
													<div
														className="event-table-side-header staff-name"
														key={event.id}
														style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
													>
														<div className="flex flex-col weekly-calendar-event">
															<WeekEventChip
																event={event}
																printView={!!printView}
																refresh={refresh}
																setCurrentSelectedEvent={setCurrentSelectedEvent}
																setEventModalOpen={setEventModalOpen}
																setRefresh={setRefresh}
															/>
														</div>
													</div>
												))}
										</div>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
				{loading ? (
					<div className="loading-spinner">
						<CircularProgress size={35} />
					</div>
				) : null}
				{!loading && !events ? (
					<div className="no-schedules">
						<p>No Events</p>
					</div>
				) : null}
			</div>
		</>
	);
};

const WeekEventChip = ({ event, printView, setEventModalOpen, setCurrentSelectedEvent }) => {
	const randomNumber = useMemo(() => {
		return Math.ceil(Math.random() * 6);
	}, [event.id]);

	const handleOpenEventModal = () => {
		setEventModalOpen(true);
		setCurrentSelectedEvent(event);
	};

	const isCustomEvent = event?.type === '39';

	return printView ? (
		isCustomEvent ? (
			event?.custom_type
		) : (
			event?.event_type?.type
		)
	) : (
		<div>
			<div
				className={`px-10 weekly-event event-random-${randomNumber} rounded-full flex justify-between items-center cursor-pointer`}
				onClick={handleOpenEventModal}
				onKeyDown={(e) => {
					if (e.key === 'Enter') {
						handleOpenEventModal();
					}
				}}
				role="button"
				tabIndex={0}
			>
				<span className="text-pd-xs  md:text-pd-sm md:mx-0">
					{isCustomEvent ? event?.custom_type : event?.event_type?.type}
				</span>
				<Avatar alt={event.event_type.type} className="md:w-44 md:h-44" src={event.event_type.icon_url} />
			</div>
		</div>
	);
};

export default WeeklyCalendar;
